import axios from '@src/utils/axios'

const module = 'job'
const hrflow = 'hrflow'
const axiosInstance = axios(false);
const axiosWebcralwer = axios(true);

export default {
  'pagination': (ctx, data) => axiosInstance.get(`/${module}/paginate`, {params:data}),
  'stagingJob': (ctx, data) => axiosInstance.get(`/${module}/staging_jobs`, {params:data}),
  'findStagingJob': (ctx, data) => axiosInstance.get(`/${module}/view-staging-job/${data.id}`, { params: data }),
  'hrflowSearch': (ctx, data) => axiosInstance.get(`/${hrflow}/searching`, { params: data }),
  'downloadData': (ctx, data) => axiosInstance.get(`/${module}/download_jobs`, {params:data}),
  'create': (ctx, data) => axiosInstance.post(`/${module}`, data),
  'update': (ctx, data) => {return axiosInstance.put(`/${module}/` + data.id, data)},
  'updateField': (ctx, data) => {return axiosInstance.put(`/${module}/update_job_field/` + data.id, data)},
  'rephraseDescription': (ctx, data) => {return axiosInstance.put(`/${module}/rephrase_description/` + data.id, data)},
  'summarizeDescription': (ctx, data) => {return axiosInstance.put(`/${module}/summarize_description/` + data.id, data)},
  'find': async (ctx, data) => {return await axiosInstance.get(`/${module}/` + data.id)},
  'getUrl': async (ctx, data) => {return await axiosInstance.get(`/${module}/url/` + data.id)},
  'getCompanyUrl': async (ctx, data) => {return await axiosInstance.get(`/${module}/company_url/` + data.id)},
  'activate':  (ctx, data) =>  axiosInstance.post(`/${module}/activate`, data),
  'applyJob':  (ctx, data) =>  axiosInstance.post(`/${module}/application`, data),
  'submitCandidate':  (ctx, data) =>  axiosInstance.post(`/${module}/submit_candidate`, data),
  'scrapedata': (ctx, data) => axiosWebcralwer.post(`/web_crawler/scrapejob`, data),
  'createNote': (ctx, data) => axiosInstance.post(`/${module}/create_note`, data),
  'getApplicants':  (ctx, data) =>  axiosInstance.get(`/${module}/applicants/` + data.id, {params:data}),
  'updateApplicant':  (ctx, data) =>  axiosInstance.put(`/${module}/update_applicant/` + data.id, data),
  'publishJob': (ctx, data) =>  axiosInstance.post(`/${module}/publish_job`, data),
  'updateOriginalFields': (ctx, data) =>  axiosInstance.post(`/${module}/update_original_fields`, data),
  'removeApplicant': (ctx, data) => axiosInstance.delete(`/${module}/remove_applicant/` + data.id),
  'generateUrl': (ctx, data) => axiosInstance.get(`/${module}/generate_url/` + data.id, {params:data}),
  'viewJob': (ctx, data) => axiosInstance.get(`/${module}/view_job/` + data.token),
  'getTitle':  (ctx, data) =>  axiosInstance.get(`/${module}/get_jobs`, {params:data}),
  'getTemplate':  (ctx, data) =>  axiosInstance.get(`/${module}/template/${ data.webcrawler_id }`),
  'getVincereJob': (ctx, data) => axiosInstance.get(`vincere/get_job`, data),
  'delete': (ctx, data) => axiosInstance.delete(`/${module}/${data.id}`, { params: data })
}